export default __webpack_public_path__ + "static/media/promo-bg-mobile.9f82bbf6.png";